import angular from 'angular';

import SiteOperationalStatusIndicatorComponent from './site-operational-status-indicator-component';

export default angular
  .module('site-operational-status-indicator', [])
  .component('siteOperationalStatusIndicator', new SiteOperationalStatusIndicatorComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/site-operational-status/components/site-operational-status-indicator/site-operational-status-indicator-module.js